module.exports = __webpack_public_path__ + "static/media/handshake.49944d90.jpg";